import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../tailwind.config.js';

export default function isMobile(): boolean {
  const fullConfig = resolveConfig(tailwindConfig);
  const mediumScreenWidthBreakpoint = fullConfig.theme.screens['md'];
  const mediumScreenWidthBreakpointPx = parseInt(mediumScreenWidthBreakpoint.replace('px', ''));
  return window?.innerWidth < mediumScreenWidthBreakpointPx;
}
